/* MBG homepage logo rotation — crossfades between the primary and
   alternate header logo at a few major section boundaries (Drop 001,
   Editorial/Brand, Footer). Only runs when an alternate logo is actually
   configured (the alt <img> only exists in the markup on the homepage,
   and only when the "Alternate logo" theme setting is set) — on every
   other page, and with no alternate logo set, this does nothing and the
   header shows a single stable logo exactly as before. */
(function () {
  'use strict';

  var slot = document.querySelector('.site-header__logo-slot');
  if (!slot || !slot.querySelector('.site-header__logo-image--alt')) {
    return;
  }

  if (!('IntersectionObserver' in window)) {
    return;
  }

  var TRIGGERS = [
    { selector: '#shopify-section-mbg-drop', state: 'alt' },
    { selector: '#shopify-section-mbg-editorial', state: 'primary' },
    { selector: '#shopify-section-footer', state: 'alt' }
  ];

  var targets = [];
  TRIGGERS.forEach(function (trigger) {
    var el = document.querySelector(trigger.selector);
    if (el) {
      targets.push({ el: el, state: trigger.state });
    }
  });

  if (!targets.length) {
    return;
  }

  var header = document.querySelector('.site-header');
  var headerHeight = header ? header.offsetHeight : 80;

  function setState(state) {
    slot.classList.toggle('mbg-logo-slot--alt', state === 'alt');
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }
        for (var i = 0; i < targets.length; i++) {
          if (targets[i].el === entry.target) {
            setState(targets[i].state);
            break;
          }
        }
      });
    },
    { rootMargin: '-' + headerHeight + 'px 0px -70% 0px', threshold: 0 }
  );

  targets.forEach(function (target) {
    observer.observe(target.el);
  });
})();
